import React from "react";
import { createRoot } from "react-dom/client";
import { ReaderApp } from "./reader/ReaderApp.jsx";

const rootElement = document.getElementById("reader-app-root");
const book = document.getElementById("book");
const layoutElement = document.querySelector(".book-reading-layout");
const data = window.ZENAS_ENRICHMENTS_DATA || { version: 1, items: [] };

if (rootElement && book && layoutElement) {
  createRoot(rootElement).render(
    <React.StrictMode>
      <ReaderApp book={book} layoutElement={layoutElement} data={data} />
    </React.StrictMode>
  );
}
